// require local scripts
require('./scripts/scripts.js');

// Require SASS
require('../sass/main.scss');


// WEBPACK FOOTER //
// ./assets/js/app.js